import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const CreateUserSchema = T.Object({
  name: T.String({ format: 'fullname', error: 'Campo obrigatório' }),
  phone: T.Optional(
    T.Intersect([
      T.String({ error: 'O campo é obrigatório' }),
      T.String({ format: 'mobile', error: 'O formato é inválido' }),
    ])
  ),
  email: T.Optional(
    T.Intersect([
      T.String({ error: 'O campo email é obrigatório' }),
      T.String({ format: 'email', error: 'O formato é inválido' }),
    ])
  ),
  registration: T.Optional(T.String()),
  role: T.String({ format: 'uuid', error: 'Cargo é um campo obrigatório' }),
  responsibleUser: T.String({ format: 'uuid', error: 'Responsável direto é um campo obrigatório' }),
  tenantUuid: T.Optional(T.String({ format: 'uuid', error: 'Aplicação inválida' })),
});

export type CreateUserInputType = typeof CreateUserSchema.static;

export async function ValidateCreateUserInput(value: unknown): Promise<CreateUserInputType> {
  return Value.Parse(CreateUserSchema, value);
}

export function checkUserCreateInput(field: string, value: unknown): string | boolean {
  return validateField(CreateUserSchema, field, value);
}
